// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"152":"1b98585de13a68b0","199":"d106fadb9dd5982e","291":"5b96115bc223ab27","585":"1fbe674ec3aebafb","617":"3f1e13cf35c08b16"}[chunkId] + ".js";
};